module.exports = __webpack_public_path__ + "img/retirement_sheet_manual.855f1cc4.jpeg";